import { render, staticRenderFns } from "./ISRtopConfig.vue?vue&type=template&id=955ac2ec&scoped=true&"
import script from "./ISRtopConfig.vue?vue&type=script&lang=js&"
export * from "./ISRtopConfig.vue?vue&type=script&lang=js&"
import style0 from "./ISRtopConfig.vue?vue&type=style&index=0&id=955ac2ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "955ac2ec",
  null
  
)

export default component.exports